export const pluralize = (count: number, word: string): string =>
  `${word}${Number(count) > 1 ? 's' : ''}`;

export const pluralizeWithCount = (count: number, word: string): string =>
  `${count} ${pluralize(count, word)}`;
